import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DepartmentsComponent } from './pages/departments/departments.component';
import { DevicesComponent } from './pages/devices/devices.component';
import { LoginComponent } from './pages/login/login.component';
import { ScenariosComponent } from './pages/scenarios/scenarios.component';
import { AddUserComponent } from './pages/users/add/add.component';
import { EditUserComponent } from './pages/users/edit/edit.component';
import { UsersComponent } from './pages/users/users.component';
import { EditDeviceComponent } from './pages/devices/edit/edit.component'
import { AddDeviceComponent } from './pages/devices/add/add.component';
import { AddScenarioComponent } from './pages/scenarios/add/add.component';
import { EditScenarioComponent } from './pages/scenarios/edit/edit.component';
import { AssignDevicesComponent } from './pages/devices/assign/assign.component';

const routes: Routes = [
  {path: 'logon', component: LoginComponent},
  {path: 'users', component: UsersComponent},
  {path: 'users/:id', component: EditUserComponent},
  {path: 'users/add/', component: AddUserComponent},
  {path: 'devices', component: DevicesComponent},
  {path: 'devices/:id', component: EditDeviceComponent},
  {path: 'devices/add/', component: AddDeviceComponent},
  {path: 'devices/assign/:id', component: AssignDevicesComponent},
  {path: 'scenarios', component: ScenariosComponent},
  {path: 'scenarios/add/', component: AddScenarioComponent},
  {path: 'scenarios/:id', component: EditScenarioComponent},
  {path: 'departments', component: DepartmentsComponent},
  {path: '**' ,component: DevicesComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: false})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
